import styled from 'styled-components';

export const PortalStyles = styled.div`
  .modal__content--alert,
  .modal__content {
    background-color: ${({ theme }) => theme.colors.background.primary};
  }

  .modal__content--side-menu,
  .modal__content--grey-background {
    background-color: ${({ theme }) => theme.colors.background.secondary};
  }
  .modal__content--side-menu-background-tertiary,
  .modal__content--grey-background-background-tertiary {
    background-color: ${({ theme }) => theme.colors.background.tertiary};
  }
`;
